module.exports = __webpack_public_path__ + "img/Layer_8.6eb3ddbb.png";